import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ApiProductStatus, FeatureFlagUseCase, ProductAlias, ProductStatus } from '@ibk/shared-types';
import { Icon } from '@ibk/shared-ui';
import { generateMenuItems, resolveMyClientsAccess } from '@ibk/shared-utils';
export const supportClientMenuItem = { label: 'Suporte', icon: _jsx(Icon, { name: 'question' }), path: '/suporte' };
function resolveHasMyClientsAccess({ shouldShowAllMenuItems, shouldShowOnlyMeuContador, hasBillingPermission, hasMyClientsProductAccess, }) {
    if (shouldShowAllMenuItems) {
        return hasMyClientsProductAccess;
    }
    if (shouldShowOnlyMeuContador) {
        return false;
    }
    return resolveMyClientsAccess({ hasBillingPermission, hasMyClientsProductAccess });
}
function buildClientMenuPermissions({ shouldShowAllMenuItems, shouldShowOnlyMeuContador, hasBillingPermission, hasAccountPjPermission, hasDigitalAccountingPermission, hasBenefitPermission, hasClientCenterPermission, isClientContabilidadeDigitalActive, isCreditoPjFeatureEnabled, isCreditoPjHiddenByAllowlist, }) {
    const hasCreditoPjAccess = isCreditoPjFeatureEnabled && !isCreditoPjHiddenByAllowlist;
    if (shouldShowAllMenuItems) {
        return {
            hasBillingAccess: true,
            hasAccountPjAccess: true,
            hasDigitalAccountingAccess: true,
            hasBenefitAccess: true,
            hasCreditoPjAccess,
            hasClientCenterAccess: true,
        };
    }
    if (shouldShowOnlyMeuContador) {
        return {
            hasBillingAccess: false,
            hasAccountPjAccess: false,
            hasDigitalAccountingAccess: true,
            hasBenefitAccess: false,
            hasCreditoPjAccess: false,
            hasClientCenterAccess: false,
        };
    }
    return {
        hasBillingAccess: !!hasBillingPermission,
        hasAccountPjAccess: !!hasAccountPjPermission,
        hasDigitalAccountingAccess: !!hasDigitalAccountingPermission && isClientContabilidadeDigitalActive,
        hasBenefitAccess: !!hasBenefitPermission,
        hasCreditoPjAccess,
        hasClientCenterAccess: !!hasClientCenterPermission,
    };
}
export function buildClientMenu({ products, isFeatureFlagWhiteListed, personId, shouldShowAllMenuItems, shouldShowOnlyMeuContador, hasBillingPermission, hasAccountPjPermission, hasDigitalAccountingPermission, hasBenefitPermission, hasClientCenterPermission, hasClientPortalViewPermission, canAccessNFSe, hasMyClientsProductAccess, t, }) {
    const clientContabilidadeDigitalProduct = products[ProductAlias.CONTABILIDADE_DIGITAL];
    const isClientContabilidadeDigitalActive = !clientContabilidadeDigitalProduct.isLoading &&
        clientContabilidadeDigitalProduct.data?.status === ApiProductStatus.ACTIVE;
    const isCreditoPjFeatureEnabled = !!isFeatureFlagWhiteListed(FeatureFlagUseCase.CREDITO_PJ_BANNER);
    const isCreditoPjHiddenByAllowlist = !!isFeatureFlagWhiteListed(FeatureFlagUseCase.CREDITO_PJ_HIDE_UI);
    const hasErpSettingsAccess = !!personId && !!isFeatureFlagWhiteListed(FeatureFlagUseCase.ERP_SETTINGS);
    const hasMyClientsAccess = resolveHasMyClientsAccess({
        shouldShowAllMenuItems,
        shouldShowOnlyMeuContador,
        hasBillingPermission,
        hasMyClientsProductAccess,
    });
    const permissionObject = buildClientMenuPermissions({
        shouldShowAllMenuItems,
        shouldShowOnlyMeuContador,
        hasBillingPermission,
        hasAccountPjPermission,
        hasDigitalAccountingPermission,
        hasBenefitPermission,
        hasClientCenterPermission,
        isClientContabilidadeDigitalActive,
        isCreditoPjFeatureEnabled,
        isCreditoPjHiddenByAllowlist,
    });
    const menuConfig = {
        domain: 'empresa',
        hasBillingAccess: permissionObject.hasBillingAccess,
        hasMyClientsAccess,
        hasNFSeMenuAccess: canAccessNFSe,
        supportMenuItem: supportClientMenuItem,
        IconComponent: Icon,
        ProductStatus: ProductStatus,
        hasAccountPjAccess: permissionObject.hasAccountPjAccess,
        hasDigitalAccountingAccess: permissionObject.hasDigitalAccountingAccess,
        hasClientPortalViewPermission: !!hasClientPortalViewPermission,
        hasBenefitAccess: permissionObject.hasBenefitAccess,
        hasCreditoPjAccess: permissionObject.hasCreditoPjAccess,
        hasErpSettingsAccess,
        hasLoyaltyProgramAccess: false,
        translate: t,
    };
    const baseMenuItems = generateMenuItems({ ...menuConfig, hasTwoOrMoreAccesses: false });
    if (hasErpSettingsAccess) {
        return [{ label: t('erp-home.menu'), icon: _jsx(Icon, { name: 'home' }), path: '/home' }, ...baseMenuItems];
    }
    const functionalMenuItemsCount = baseMenuItems.filter(item => item.path !== supportClientMenuItem.path).length;
    const hasTwoOrMoreAccesses = functionalMenuItemsCount >= 2;
    return hasTwoOrMoreAccesses ? generateMenuItems({ ...menuConfig, hasTwoOrMoreAccesses: true }) : baseMenuItems;
}
